import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const WrapperPopup = ({
  triggerProps,
  contentStyleProps,
  arrowStyleProps,
  children,
  positionProps,
}) => {
  return (
    <Popup
      on={["hover", "focus"]}
      position={positionProps}
      trigger={triggerProps}
      contentStyle={contentStyleProps}
      arrowStyle={arrowStyleProps}
    >
      {children}
    </Popup>
  );
};

export default WrapperPopup;
